import {
  GET_LANDING_DROPDOWN_LIST,
  GET_LANDING_DROPDOWN_LIST_FAILED,
  GET_LANDING_DROPDOWN_LIST_SUCCESS,
  GET_LANDING_SETUP,
  GET_LANDING_SETUP_FAILED,
  GET_LANDING_SETUP_SUCCESS,
  UPDATE_LANDING_FEATURE_ORDER,
  UPDATE_LANDING_FEATURE_ORDER_FAILED,
  UPDATE_LANDING_FEATURE_ORDER_SUCCESS,
  UPDATE_LANDING_SETUP,
  UPDATE_LANDING_SETUP_FAILED,
  UPDATE_LANDING_SETUP_SUCCESS,
} from "./actionTypes"

export const getLandingSetup = params => ({
  type: GET_LANDING_SETUP,
  payload: params,
})

export const getLandingSetupSuccess = response => ({
  type: GET_LANDING_SETUP_SUCCESS,
  payload: response,
})

export const getLandingSetupFailed = error => ({
  type: GET_LANDING_SETUP_FAILED,
  payload: error,
})

export const getLandingDropdownList = params => ({
  type: GET_LANDING_DROPDOWN_LIST,
  payload: params,
})

export const getLandingDropdownListSuccess = response => ({
  type: GET_LANDING_DROPDOWN_LIST_SUCCESS,
  payload: response,
})

export const getLandingDropdownListFailed = error => ({
  type: GET_LANDING_DROPDOWN_LIST_FAILED,
  payload: error,
})

export const updateLandingSetup = params => ({
  type: UPDATE_LANDING_SETUP,
  payload: params,
})

export const updateLandingSetupSuccess = response => ({
  type: UPDATE_LANDING_SETUP_SUCCESS,
  payload: response,
})

export const updateLandingSetupFailed = error => ({
  type: UPDATE_LANDING_SETUP_FAILED,
  payload: error,
})

export const updateLandingFeatureOrder = params => ({
  type: UPDATE_LANDING_FEATURE_ORDER,
  payload: params,
})

export const updateLandingFeatureOrderSuccess = response => ({
  type: UPDATE_LANDING_FEATURE_ORDER_SUCCESS,
  payload: response,
})

export const updateLandingFeatureOrderFailed = error => ({
  type: UPDATE_LANDING_FEATURE_ORDER_FAILED,
  payload: error,
})
